import type { FormStepperItemCallbackOptions } from '@/components/tripBookingPage/tripBooking';
import type { Companionship } from '@/types';
/**
 * Retourne le libellé calculé en fonction du nombre d'accompagnateurs pour chaque catégorie (enfant, parent, autres).
 */
export default {
  getTravellingCompanionsLabel: (companionship: Companionship | undefined, { t }: FormStepperItemCallbackOptions) => {
    const count = companionship && companionship.type === 'auto'
      ? (companionship.companions.parents ?? 0) + (companionship.companions.children ?? 0)
      : companionship?.type === 'select'
        ? (companionship.companions.parents?.numberOfCompanions.max ?? 0) + (companionship.companions.children?.numberOfCompanions.max ?? 0)
        : 0;

    return t('pages.tripBooking.forms.items.companions.types.travelling.label', count);
  },

  getParentCompanionsLabel: (companionship: Companionship | undefined, { t }: FormStepperItemCallbackOptions) => {
    const max = companionship && companionship.type === 'auto'
      ? companionship.companions.parents ?? 0
      : companionship?.type === 'select'
        ? companionship.companions.parents?.numberOfCompanions.max ?? 0
        : 0;
    return t('pages.tripBooking.forms.items.companions.types.parents.label', max);
  },
  getChildrenCompanionsLabel: (companionship: Companionship | undefined, { t }: FormStepperItemCallbackOptions) => {
    const max = companionship && companionship.type === 'auto'
      ? companionship.companions.children ?? 0
      : companionship?.type === 'select'
        ? companionship.companions.children?.numberOfCompanions.max ?? 0
        : 0;

    return t('pages.tripBooking.forms.items.companions.types.children.label', max);
  },

};
